// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ee1d1b7a","453":"70d4c0ee","814":"7e965012"}[chunkId] + ".chunk.js";
};